import type { AssessmentQuestion } from '@entities/assessment'

import { AssessmentTopics } from '@entities/assessment'

import imgQuestion2 from '../../../../ui/images/questions/ela/grade-k5/question-2.png'
import imgQuestion5 from '../../../../ui/images/questions/ela/grade-k5/question-5.png'
import imgQuestion12 from '../../../../ui/images/questions/ela/grade-k5/question-12.png'

export const questionsTest: AssessmentQuestion[] = [
  {
    name: 'grade_k5_1',
    title: 'Read the sentence:',
    topic: AssessmentTopics.ListeningAndSpeaking,
    detail: '"Well, that was just great," he said with a frown.',
    sentence: 'What does he most likely mean?',
    answers: [
      {
        name: 'grade_k5_1_a',
        text: 'He is truly happy.',
      },
      {
        name: 'grade_k5_1_b',
        text: 'He is being sarcastic.',
        correct: true,
      },
      {
        name: 'grade_k5_1_c',
        text: 'He is giving a compliment.',
      },
    ],
  },
  {
    name: 'grade_k5_2',
    title: 'If your teacher says, "Please speak clearly so everyone can understand you," what should you do?',
    topic: AssessmentTopics.ListeningAndSpeaking,
    image: imgQuestion2,
    answers: [
      {
        name: 'grade_k5_2_a',
        text: 'Whisper your answer.',
      },
      {
        name: 'grade_k5_2_b',
        text: 'Talk at a steady pace and pronounce words carefully.',
        correct: true,
      },
      {
        name: 'grade_k5_2_c',
        text: 'Say it quickly and quietly.',
      },
    ],
  },
  {
    name: 'grade_k5_3',
    title: 'Read the sentence:',
    topic: AssessmentTopics.ListeningAndSpeaking,
    detail: '"I know you\'re nervous about the talent show, but you\'ve practiced so much. Just go out there and break a leg!"',
    sentence: 'What is the speaker telling the performer to do?',
    answers: [
      {
        name: 'grade_k5_3_a',
        text: 'Be careful not to fall on stage.',
      },
      {
        name: 'grade_k5_3_b',
        text: 'Do a great job and have a successful performance.',
        correct: true,
      },
      {
        name: 'grade_k5_3_c',
        text: 'Try to get injured so they don\'t have to perform.',
      },
    ],
  },
  {
    name: 'grade_k5_4',
    title: 'Read the sentence:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: '"He slipped on the ice and broke his arm."',
    sentence: 'What was the effect?',
    answers: [
      {
        name: 'grade_k5_4_a',
        text: 'He slipped on the ice',
      },
      {
        name: 'grade_k5_4_b',
        text: 'It was cold',
      },
      {
        name: 'grade_k5_4_c',
        text: 'He broke his arm',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k5_5',
    title: 'Read the text:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: '"Because Ben dedicated his weekends to refining his painting techniques, his artwork stood out among hundreds of other entries. The judges were impressed by his attention to detail."',
    sentence: 'What was the primary cause of Ben winning the art contest?',
    image: imgQuestion5,
    answers: [
      {
        name: 'grade_k5_5_a',
        text: 'He possessed a higher level of innate talent than the other competitors.',
      },
      {
        name: 'grade_k5_5_b',
        text: 'He committed his private leisure hours to polishing and mastering his craft.',
        correct: true,
      },
      {
        name: 'grade_k5_5_c',
        text: 'He submitted a larger quantity of illustrations than his classmates.',
      },
    ],
  },
  {
    name: 'grade_k5_6',
    title: 'Read the text:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: '"The scientist\'s discovery was so revolutionary that it completely changed how people thought about clean energy. Old methods were quickly abandoned in favor of her new, efficient design."',
    sentence: 'Based on the text, what does the word "revolutionary" most likely mean?',
    answers: [
      {
        name: 'grade_k5_6_a',
        text: 'Something that has been done many times before.',
      },
      {
        name: 'grade_k5_6_b',
        text: 'Causing a total and dramatic change.',
        correct: true,
      },
      {
        name: 'grade_k5_6_c',
        text: 'Very expensive and difficult to understand.',
      },
    ],
  },
  {
    name: 'grade_k5_7',
    title: 'Which sentence uses punctuation correctly?',
    topic: AssessmentTopics.Writing,
    answers: [
      {
        name: 'grade_k5_7_a',
        text: 'She said "I will come tomorrow".',
      },
      {
        name: 'grade_k5_7_b',
        text: 'She said, "I will come tomorrow".',
      },
      {
        name: 'grade_k5_7_c',
        text: 'She said, "I will come tomorrow."',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k5_8',
    title: 'Choose the sentence that is written correctly:',
    topic: AssessmentTopics.Writing,
    answers: [
      {
        name: 'grade_k5_8_a',
        text: 'my sister loves to read, she has many books.',
      },
      {
        name: 'grade_k5_8_b',
        text: 'My sister loves to read she has many books.',
      },
      {
        name: 'grade_k5_8_c',
        text: 'My sister loves to read. She has many books.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k5_9',
    title: 'Which is the best way to combine these two sentences?',
    topic: AssessmentTopics.Writing,
    detail: 'The sun was shining. We went to the park.',
    answers: [
      {
        name: 'grade_k5_9_a',
        text: 'The sun was shining, we went to the park.',
      },
      {
        name: 'grade_k5_9_b',
        text: 'Since the sun was shining, we went to the park.',
        correct: true,
      },
      {
        name: 'grade_k5_9_c',
        text: 'The sun was shining we went to the park.',
      },
    ],
  },
  {
    name: 'grade_k5_10',
    title: 'Identify the preposition in this sentence:',
    topic: AssessmentTopics.Language,
    detail: 'The cat slept under the warm blanket.',
    answers: [
      {
        name: 'grade_k5_10_a',
        text: 'cat',
      },
      {
        name: 'grade_k5_10_b',
        text: 'slept',
      },
      {
        name: 'grade_k5_10_c',
        text: 'under',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k5_11',
    title: 'Which sentence is written in passive voice?',
    topic: AssessmentTopics.Language,
    answers: [
      {
        name: 'grade_k5_11_a',
        text: 'The teacher gave the students homework.',
      },
      {
        name: 'grade_k5_11_b',
        text: 'The homework was given to the students by the teacher.',
        correct: true,
      },
      {
        name: 'grade_k5_11_c',
        text: 'The students completed their homework.',
      },
    ],
  },
  {
    name: 'grade_k5_12',
    title: 'Which word is an adverb in this sentence?',
    topic: AssessmentTopics.Language,
    detail: 'The student quickly finished the test and handed it in.',
    image: imgQuestion12,
    answers: [
      {
        name: 'grade_k5_12_a',
        text: 'student',
      },
      {
        name: 'grade_k5_12_b',
        text: 'quickly',
        correct: true,
      },
      {
        name: 'grade_k5_12_c',
        text: 'finished',
      },
    ],
  },
]
